<script>
import { businessHours } from '@/util/hours.js'

export default {
    name: 'Hours',
    computed: {
        label() {
            return `${businessHours.days}, ${businessHours.open} – ${businessHours.close} ${businessHours.timezone}`
        },
    },
}
</script>

<template>
    <span class="hours">{{ label }}</span>
</template>

<style>
</style>
